import React, { ReactNode } from 'react';

import Grid from '@material-ui/core/Grid';

import { formatAmount, fractionToPercent } from 'helpers/helpers';
import useGeneralStyles from 'apps/Pdf/styles/general';
import useStyles from './FeeLineStyle';
import { AmountValue } from 'common/interfaces';
import { Currency } from 'enums';

interface Props {
  heading?: string;
  subheading?: string;
  title: string;
  subtitle?: string;
  amount?: AmountValue;
  percentage?: number;
  customValue?: ReactNode;
  max?: boolean;
  currency?: Currency;
  variant?: 'main' | 'main2' | 'sub' | 'detail';
  pa?: boolean;
  noBorder?: boolean;
  boldValue?: boolean;
  wideTitle?: boolean;
  zeroFee?: boolean;
}

const FeeLine = (props: Props) => {
  const styles = useGeneralStyles();
  const classes = useStyles();

  return (
    <Grid
      container
      alignItems="center"
      className={`${styles.lines} ${styles.regularText} ${classes.root}
      ${props.variant === 'main' ? 'bgrLighter' : ''}
      ${props.variant === 'main2' ? 'main2' : ''}
      ${props.noBorder ? 'noBorder' : ''}
      ${props.variant === 'sub' ? 'sub' : ''}
      `}
    >
      {props.heading !== undefined || props.subheading !== undefined ? (
        <>
          <Grid item xs={4}>
            {props.heading}
            {props.heading && props.subheading && <br />}
            {props.subheading && <span className={styles.supplement}>{props.subheading}</span>}
          </Grid>
          <Grid item xs={4} className={styles.supplement}>
            {props.title}
          </Grid>
        </>
      ) : (
        <Grid
          item
          xs={props.variant === 'detail' ? 12 : props.wideTitle ? 10 : 8}
          className={`${props.variant === 'main2' ? styles.bold : ''}`}
        >
          {props.title}
          {props.subtitle && <span className={styles.supplement}> {props.subtitle}</span>}
        </Grid>
      )}
      {props.variant !== 'detail' && (
        <Grid
          item
          xs={props.wideTitle ? 2 : 4}
          className={`${styles.right} ${props.variant === 'main' || props.boldValue ? styles.bold : ''}`}
        >
          {props.max && 'max. '}
          {props.amount && props.currency && (
            <>
              {props.amount.value === 0 && props.zeroFee
                ? 'v ceně poplatku'
                : formatAmount(props.amount, props.currency)}
            </>
          )}
          {props.percentage !== undefined &&
            (props.percentage === 0 && props.zeroFee ? 'v ceně poplatku' : fractionToPercent(props.percentage, 2))}
          {props.customValue}
          {props.pa && ' p. a.'}
        </Grid>
      )}
    </Grid>
  );
};

export default FeeLine;
